import styles from "UserCrowd/components/heading/heading.module.scss"
import { createStyledComponent } from "Utilities/component-factory"

export const H1 = createStyledComponent("h1", `heading ${styles.h1}`)
export const H2 = createStyledComponent("h2", `heading ${styles.h2}`)
